import React from 'react';
import { CtaButton } from './CtaButton';
const systemFacts = [{
  value: '+300',
  label: 'Mapas mentales'
}, {
  value: '6',
  label: 'Niveles de inglés'
}, {
  value: '50',
  label: 'Mapas por nivel'
}, {
  value: '+1.000',
  label: 'Ejercicios prácticos'
}];
export function FinalCtaSection() {
  return <section aria-labelledby="cierre" className="bg-ink text-cream" data-id="element-90" data-mp="3vsw29kzhfp62">
      
    </section>;
}